export default "__VITE_ASSET__62KZThFx__"